import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import client from "@/lib/api";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import ParticleField from "@/components/ParticleField";

export default function Newsroom() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    client.get("/articles").then(({ data }) => setArticles(data)).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title="Newsroom — ImJove Tech" description="Company announcements, product launches, founder updates, and technology developments from ImJove Tech." />
      <section className="relative overflow-hidden pb-16 pt-40">
        <ParticleField className="absolute inset-0 z-0" density={30} />
        <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <p className="font-mono2 text-xs uppercase tracking-brand text-gold-light">Newsroom</p>
            <h1 className="mt-4 max-w-3xl font-display text-5xl font-bold tracking-tighter text-white sm:text-6xl">The latest from ImJove Tech.</h1>
          </Reveal>
        </div>
      </section>

      <section className="pb-28">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {articles.map((a, i) => (
              <Reveal key={a.id} delay={i * 0.06}>
                <Link to={`/newsroom/${a.slug}`} data-testid={`article-${a.slug}`} className="card-hover group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-800">
                  {a.cover_image && (
                    <div className="aspect-[16/9] overflow-hidden">
                      <img src={a.cover_image} alt={a.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    </div>
                  )}
                  <div className="flex flex-1 flex-col p-7">
                    <span className="font-mono2 text-[10px] uppercase tracking-widest text-gold-light">{a.category}</span>
                    <h3 className="mt-3 font-display text-xl font-semibold text-white">{a.title}</h3>
                    <p className="mt-3 flex-1 font-body text-sm text-white/55">{a.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 font-mono2 text-[11px] uppercase tracking-widest text-white/70 group-hover:text-gold-light">Read <ArrowUpRight size={13} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          {articles.length === 0 && <p className="font-body text-white/40">No articles yet.</p>}
        </div>
      </section>
    </div>
  );
}
